import {ALGOLIA_PERMITTED_NAV_PARAMS} from 'algolia_listing_pages/utils/algolia_constants';
import searchParams from 'utils/url';

export default function productSearchParams(
  activeColorId,
  promoBadge,
  initialSelectedColorId
) {
  const currentSearchParams = searchParams();

  currentSearchParams.forEach((_value, key) => {
    if (!ALGOLIA_PERMITTED_NAV_PARAMS.some((param) => key.startsWith(param))) {
      currentSearchParams.delete(key);
    }
  });

  if (activeColorId) {
    currentSearchParams.append('PK', activeColorId);
  }
  // Add badge parameter to show loading skeleton while badge info loads from Algolia
  // Prevents layout shift of product name during badge loading
  if (promoBadge) {
    currentSearchParams.append('bg', 1);
  }

  if (currentSearchParams.get('min_qty[]')) {
    currentSearchParams.delete('min_qty[]');
    currentSearchParams.append('quote_qty', 'min');
  }

  // Avoid duplicate PK parameter
  if (
    !currentSearchParams.get('PK') &&
    activeColorId &&
    initialSelectedColorId
  ) {
    currentSearchParams.append('PK', activeColorId);
  }

  return currentSearchParams;
}
